import { SecurityDomain } from '../enums/security-domain';
import { EnterpriseLabels } from '../interfaces/enterprise-labels';

export function getEnterpriseLabels(securityDomain: SecurityDomain): EnterpriseLabels {
    const isEyefinity = securityDomain === SecurityDomain.EYEFINITY;

    return {
        universalIdsLabel: isEyefinity ? 'EHR Global IDs' : 'Universal IDs',
        universalIdLabel: isEyefinity ? 'EHR Global ID' : 'Universal ID',
        universalIdsFilenameLabel: isEyefinity ? 'EHR-Global-IDs' : 'Universal-IDs',
        accountsLabel: isEyefinity ? 'EHR Accounts' : 'EMA Accounts',
        accountLabel: isEyefinity ? 'EHR Account' : 'EMA Account',
        usernameLabel: isEyefinity ? 'EHR Username' : 'EMA Username',
        idManagementLabel: isEyefinity ? 'EHR Global ID Management' : 'Universal ID Management',
        isEnterpriseEyefinity: isEyefinity
    };
}
